/**
 * Redirects to the "complete your profile" step when the authenticated user has no
 * organization on file yet — the state a first-time Google sign-up starts in.
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { RoutePaths } from '../constants';

export const profileCompleteGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.getProfile().pipe(
    take(1),
    map((user) => {
      if (user.customerProfile) {
        return true;
      }
      return router.createUrlTree([RoutePaths.COMPLETE_PROFILE]);
    })
  );
};
